import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { TermsOfService } from './pages/TermsOfService';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-5" />} data-id="element-4" />
        <Route path="/terms" element={<TermsOfService data-id="element-7" />} data-id="element-6" />
      </Routes>
    </BrowserRouter>;
}